import { render, staticRenderFns } from "./CloneTemplateModal.vue?vue&type=template&id=66d269c4"
import script from "./CloneTemplateModal.vue?vue&type=script&lang=js"
export * from "./CloneTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports